(function(){
  /* 1. Atribuire campanii: retine parametrii pe sesiune */
  var p;
  try{
    p=new URLSearchParams(location.search);
    var chei=['utm_content','utm_campaign','utm_source','utm_medium','gclid','fbclid'];
    chei.forEach(function(k){var v=p.get(k);if(v)sessionStorage.setItem('iso_'+k,v)});
    if(p.get('utm_content'))sessionStorage.setItem('iso_src',p.get('utm_content'));
    else if(p.get('utm_campaign')&&!sessionStorage.getItem('iso_src'))sessionStorage.setItem('iso_src',p.get('utm_campaign'));
  }catch(e){}

  /* 2. Atribuire parteneri: ?partener=COD se retine 90 de zile, in localStorage */
  try{
    var pc=p&&p.get('partener');
    if(pc){
      pc=String(pc).trim().toUpperCase().replace(/[^A-Z0-9_-]/g,'').slice(0,32);
      if(pc)localStorage.setItem('iso_partener',JSON.stringify({c:pc,t:Date.now()}));
    }
  }catch(e){}

  /* 3. Codul de partener ajunge pe comanda, ca atribut al cosului */
  function partener(){
    try{
      var r=JSON.parse(localStorage.getItem('iso_partener')||'null');
      if(!r||!r.c)return '';
      if(Date.now()-r.t>90*24*3600*1000){localStorage.removeItem('iso_partener');return ''}
      return r.c;
    }catch(e){return ''}
  }
  window.isoPartener=partener;
  function marcheazaCos(){
    var c=partener();if(!c)return;
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(cart){
      if(!cart||!cart.item_count)return;
      if(cart.attributes&&cart.attributes.Partener===c)return;
      return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({attributes:{Partener:c}})});
    }).catch(function(){});
  }
  marcheazaCos();

  /* 4. Sertarul de meniu */
  var b=document.getElementById('isoBurger'),d=document.getElementById('isoDrawer'),
      s=document.getElementById('isoScrim'),x=document.getElementById('isoDrawerClose');
  if(b&&d&&s){
    var open=function(){d.classList.add('on');s.classList.add('on');document.body.classList.add('iso-lock');
      b.setAttribute('aria-expanded','true');d.setAttribute('aria-hidden','false');};
    var close=function(){d.classList.remove('on');s.classList.remove('on');document.body.classList.remove('iso-lock');
      b.setAttribute('aria-expanded','false');d.setAttribute('aria-hidden','true');};
    b.addEventListener('click',open);
    if(x)x.addEventListener('click',close);
    s.addEventListener('click',close);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }

  /* 5. Antetul se strange la derulare, plus butonul de urcare */
  var hd=document.querySelector('.iso-hd'),sus=null;
  if(!document.querySelector('.iso-sus')){
    sus=document.createElement('button');
    sus.type='button';sus.className='iso-sus';sus.setAttribute('aria-label','Înapoi sus');
    sus.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5"/><path d="m5 12 7-7 7 7"/></svg>';
    sus.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'})});
    document.body.appendChild(sus);
  }
  function laDerulare(){
    var y=window.pageYOffset||document.documentElement.scrollTop;
    if(hd)hd.classList.toggle('iso-lipit',y>40);
    if(sus)sus.classList.toggle('on',y>window.innerHeight*1.6);
  }
  window.addEventListener('scroll',laDerulare,{passive:true});
  laDerulare();

  /* 6. Adaugarea in cos se face fara parasirea paginii.
        Clientul ramane pe pagina si merge in cos numai daca apasa butonul din
        confirmare. Astfel poate lua mai multe repere din aceeasi pagina. */
  var cutie=document.getElementById('isoToast'),ceas=null;

  function insigna(n){
    var a=document.querySelector('.iso-hd .iso-cart-ico')||document.querySelector('.iso-hd .iso-cart');
    if(!a)return;
    var sp=a.querySelector('.iso-count');
    if(n>0){
      if(!sp){sp=document.createElement('span');sp.className='iso-count';a.appendChild(sp)}
      sp.textContent=n;
    }else if(sp){sp.parentNode.removeChild(sp)}
  }

  function ascunde(){
    if(!cutie)return;
    cutie.classList.remove('on');
    clearTimeout(ceas);
    ceas=setTimeout(function(){cutie.hidden=true},200);
  }

  function arata(mesaj,rau){
    if(!cutie){if(rau)alert(mesaj);return}
    var bifa='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    var semn='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v6M12 16.5v.01"/></svg>';
    var url=cutie.getAttribute('data-url')||'/cart';
    var tCos=cutie.getAttribute('data-cta')||'Mergi la coș';
    var tInc=cutie.getAttribute('data-inchide')||'Continuă cumpărăturile';
    cutie.className='iso-toast'+(rau?' rau':'');
    cutie.innerHTML='<div class="tx">'+(rau?semn:bifa)+'<span></span></div>'+
      (rau?'':'<div class="ac"><a class="iso-btn iso-btn--gold" href="'+url+'"></a>'+
      '<button type="button" class="iso-btn iso-btn--line" data-iso-inchide></button></div>');
    cutie.querySelector('.tx span').textContent=mesaj;
    if(!rau){
      cutie.querySelector('.ac a').textContent=tCos;
      var bi=cutie.querySelector('[data-iso-inchide]');
      bi.textContent=tInc;
      bi.addEventListener('click',ascunde);
    }
    cutie.hidden=false;
    clearTimeout(ceas);
    requestAnimationFrame(function(){cutie.classList.add('on')});
    ceas=setTimeout(ascunde,rau?7000:9000);
  }

  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.getAttribute)return;
    var act=f.getAttribute('action')||'';
    if(act.indexOf('/cart/add')<0)return;      /* numai formularele de adaugare in cos */
    if(f.hasAttribute('data-iso-clasic'))return; /* portita de iesire, daca va fi nevoie */
    if(e.defaultPrevented)return;
    e.preventDefault();

    var buton=f.querySelector('[type=submit]');
    if(buton){
      if(buton.getAttribute('data-lucreaza'))return;
      buton.setAttribute('data-lucreaza','1');
      buton.setAttribute('aria-busy','true');
    }
    function gata(){
      if(!buton)return;
      buton.removeAttribute('data-lucreaza');
      buton.removeAttribute('aria-busy');
    }

    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',
      headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return{ok:r.ok,j:j}})})
      .then(function(rez){
        if(!rez.ok){
          var m=rez.j&&(rez.j.description||rez.j.message);
          throw new Error(m||'');
        }
        return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()});
      })
      .then(function(cos){
        insigna(cos&&cos.item_count?cos.item_count:0);
        marcheazaCos();
        arata((cutie&&cutie.getAttribute('data-ok'))||'Produsul a fost adăugat în coș.',false);
        try{document.dispatchEvent(new CustomEvent('iso:cos',{detail:cos}))}catch(er){}
        gata();
      })
      .catch(function(er){
        arata((er&&er.message)||(cutie&&cutie.getAttribute('data-err'))||'Produsul nu a putut fi adăugat în coș.',true);
        gata();
      });
  },false);
})();

/* Sursa: campania, iar in lipsa ei partenerul, iar in lipsa amandurora direct */
window.isoSursa=function(){
  try{
    var u=sessionStorage.getItem('iso_src');if(u)return u;
    var c=window.isoPartener?window.isoPartener():'';if(c)return 'partener:'+c;
  }catch(e){}
  return 'direct';
};
